export default {
  methods: {
    onlyNumberFormatter(input) {
      return input ? input.replace(/[^0-9]/g, "") : ""
    },
  },
}
